import { render } from "./StorefrontLayout.vue?vue&type=template&id=78d9d5ee&scoped=true"
import script from "./StorefrontLayout.vue?vue&type=script&lang=js"
export * from "./StorefrontLayout.vue?vue&type=script&lang=js"

import "./StorefrontLayout.vue?vue&type=style&index=0&id=78d9d5ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d9d5ee"]])

export default __exports__